import script from "./CrudEventos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudEventos.vue?vue&type=script&setup=true&lang=js"

import "./CrudEventos.vue?vue&type=style&index=0&id=32e9c483&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e9c483"]])

export default __exports__